export default __webpack_public_path__ + "static/media/firstMonthAssessmentPT.5bdc7938.png";